import React from 'react';

interface ComparisonBadgeProps {
  currentValue: number;
  previousValue: number | null | undefined;
  label?: string;
  invertColor?: boolean;
}

const ComparisonBadge: React.FC<ComparisonBadgeProps> = ({
  currentValue,
  previousValue,
  label,
  invertColor = false,
}) => {
  if (!previousValue || previousValue === 0) return null;

  const change = ((currentValue - previousValue) / Math.abs(previousValue)) * 100;
  const isUp = change > 0;
  const absChange = Math.abs(change);

  // For normal metrics: up is green (good for income/profit), down is red
  // For inverted metrics (food cost): down is green (lower cost is better), up is red
  const isImprovement = invertColor ? !isUp : isUp;
  const color = isImprovement ? '#2E7D32' : '#C62828';
  const bgColor = isImprovement ? '#E8F5E9' : '#FFEBEE';
  const arrow = isUp ? '\u2191' : '\u2193';

  const displayChange = absChange >= 1000
    ? `${(absChange / 1000).toFixed(1)}k`
    : absChange >= 100
      ? Math.round(absChange).toString()
      : absChange.toFixed(1);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        fontSize: '0.7rem',
        fontWeight: 700,
        color,
        backgroundColor: bgColor,
        borderRadius: 20,
        padding: '2px 8px',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
    >
      {arrow}{displayChange}%{label ? ` ${label}` : ' vs last month'}
    </span>
  );
};

export default ComparisonBadge;
